import React from "react"
import Card from "../../../common/blocks/card/Card"
import Button from "../../../common/blocks/button/Button"
import { categoryUrl, tagUrl } from "../../../../../utils/routeLib"

function TitleTagsHeaderBlock({ articles, Title, isTagPage }) {
  const tagOccurrences = {}
  const categoryOccurrences = {}

  articles?.forEach((article) => {
    const tags = article.attributes.tags.data || []
    tags.forEach((tag) => {
      const { label, slug } = tag.attributes
      if (tagOccurrences[label]) {
        tagOccurrences[label].countTags++
      } else {
        tagOccurrences[label] = {
          countTags: 1,
          slug,
        }
      }
    })

    const categories = article.attributes.category?.data
    if (categories) {
      const { label, autoPath } = categories.attributes
      if (categoryOccurrences[label]) {
        categoryOccurrences[label].countCategories++
      } else {
        categoryOccurrences[label] = {
          countCategories: 1,
          autoPath,
        }
      }
    }
  })

  const sortedTags = Object.keys(tagOccurrences).sort(
    (a, b) => tagOccurrences[b].countTags - tagOccurrences[a].countTags
  )

  const sortedCategories = Object.keys(categoryOccurrences).sort(
    (a, b) =>
      categoryOccurrences[b].countCategories -
      categoryOccurrences[a].countCategories
  )

  return (
    <Card className="container card_bottom flex flex-direction-column justify-content-end align-items-center text-center pbl-6 pin-3 gap-4">
      <h1>{Title}</h1>

      <div className="tags justify-content-center">
        {isTagPage
          ? sortedTags.map((tag, index) => (
              <Button
                key={index}
                to={tagUrl(tagOccurrences[tag].autoRoute)}
                aspect="tag"
                color="secondary"
              >
                {tag}
              </Button>
            ))
          : sortedCategories.map((category, index) => (
              <Button
                key={index}
                to={categoryUrl(categoryOccurrences[category].autoPath)}
                aspect="tag"
                color="secondary"
              >
                {category}
              </Button>
            ))}
      </div>
    </Card>
  )
}

export default TitleTagsHeaderBlock
